import React from 'react'
import "./Service.css"
import { Link } from 'react-router-dom';
const ServiceSection = () => {
  return (
    <div className="default-width type-container-parent">
      <div className="row row-gap-4">
        <h2 className='our_sercive_home_section'>Our Services</h2>
        <div className=" col-4 col-lg-2">
          <Link
          to='/doctor-consultant'
            className="cursor-pointer"
            
          >
            <div className="d-flex flex-column justify-content-center align-items-center  pb-3">
              <div className="type-container bg-primary-alfa">
                <img
                  alt="Doctor Consultation icon"
                  fetchpriority="high"
                  width={55}
                  height={55}
                  decoding="async"
                  data-nimg={1}
                  className="type-image"
                  src="https://cdn.hexahealth.com/static/images/services-doctor.png"
                  style={{ color: "transparent" }}
                />
              </div>
              <span className="type-heading text-center" style={{color:'#000'}}>
                Doctor Consultation
              </span>
            </div>
          </Link>
        </div>
        <div className=" col-4 col-lg-2">
          <a>
            <div className="d-flex flex-column justify-content-center align-items-center  pb-3">
              <div className="type-container bg-primary-alfa">
                <img
                  alt="Second Opinion icon"
                  fetchpriority="high"
                  width={55}
                  height={55}
                  decoding="async"
                  data-nimg={1}
                  className="type-image"
                  src="https://cdn.hexahealth.com/static/images/services-second-opinion.png"
                  style={{ color: "transparent" }}
                />
              </div>
              <span className="type-heading text-center">Second Opinion</span>
            </div>
          </a>
        </div>
        <div className=" col-4 col-lg-2">
          <a >
            <div className="d-flex flex-column justify-content-center align-items-center  pb-3">
              <div className="type-container bg-primary-alfa">
                <img
                  alt="Medical Loan icon"
                  fetchpriority="high"
                  width={55}
                  height={55}
                  decoding="async"
                  data-nimg={1}
                  className="type-image"
                  src="https://cdn.hexahealth.com/static/images/services-medical-loan.png"
                  style={{ color: "transparent" }}
                />
              </div>
              <span className="type-heading text-center">Medical Loan</span>
            </div>
          </a>
        </div>
        <div className=" col-4 col-lg-2">
          <div
            className="cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#organicLeadFormModalHS_CheckInsurance"
          >
            <div className="d-flex flex-column justify-content-center align-items-center  pb-3">
              <div className="type-container bg-primary-alfa">
                <img
                  alt="Insurance Assistance icon"
                  fetchpriority="high"
                  width={55}
                  height={55}
                  decoding="async"
                  data-nimg={1}
                  className="type-image"
                  src="https://cdn.hexahealth.com/static/images/services-appointment.png"
                  style={{ color: "transparent" }}
                />
              </div>
              <span className="type-heading text-center">
                Insurance Assistance
              </span>
            </div>
          </div>
        </div>
        <div className=" col-4 col-lg-2">
          <div
            className="cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#organicLeadFormModalHS_PostSurgeryCare"
          >
            <div className="d-flex flex-column justify-content-center align-items-center  pb-3">
              <div className="type-container bg-primary-alfa">
                <img
                  alt="Post Surgery Care icon"
                  fetchpriority="high"
                  width={55}
                  height={55}
                  decoding="async"
                  data-nimg={1}
                  className="type-image"
                  src="https://cdn.hexahealth.com/static/images/services-post-surgery-care.png"
                  style={{ color: "transparent" }}
                />
              </div>
              <span className="type-heading text-center">
                Post Surgery Care
              </span>
            </div>
          </div>
        </div>
        <div className=" col-4 col-lg-2">
          <div
            className="cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#organicLeadFormModalHS_DrConsultation"
          >
            <div className="d-flex flex-column justify-content-center align-items-center  pb-3">
              <div className="type-container bg-primary-alfa">
                <img
                  alt="Care Assistance icon"
                  fetchpriority="high"
                  width={55}
                  height={55}
                  decoding="async"
                  data-nimg={1}
                  className="type-image"
                  src="https://cdn.hexahealth.com/static/images/services-personal-care-assistance.png"
                  style={{ color: "transparent" }}
                />
              </div>
              <span className="type-heading text-center">Care Assistance</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceSection
